import React from 'react';
import { Target, PenTool, Globe, Megaphone, Sparkles, LineChart, ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../mock';

const ICON_MAP = { Target, PenTool, Globe, Megaphone, Sparkles, LineChart };

export default function Services() {
  return (
    <section id="services" className="relative py-20 md:py-28 bg-[#162028] text-[#ede2c4]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="text-[12px] uppercase tracking-[0.22em] text-[#ddc390] mb-4 flex items-center gap-2">
              <span className="h-px w-8 bg-[#ddc390]" /> Services
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl lg:text-7xl leading-[1] tracking-tight max-w-3xl">
              Our <span className="italic font-light text-[#ddc390]">comprehensive</span> range of services
            </h2>
          </div>
          <p className="text-[15px] leading-relaxed text-[#ede2c4]/70 max-w-md">
            A complete suite covering strategic branding, creative design, digital mastery, event planning, media buying and performance analytics — for a cohesive, impactful presence.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-b border-[#ede2c4]/15">
          {SERVICES.map((s, i) => {
            const Icon = ICON_MAP[s.icon];
            const borderClasses = `${i % 3 !== 2 ? 'lg:border-r' : ''} ${i < SERVICES.length - 3 ? 'lg:border-b' : ''} ${i % 2 !== 1 ? 'md:border-r lg:border-r' : 'md:border-r-0'} ${i < SERVICES.length - 2 ? 'md:border-b lg:border-b' : ''} border-b md:border-b border-[#ede2c4]/15`;
            return (
              <div key={s.key} className={`group relative p-8 md:p-10 transition-colors duration-500 hover:bg-[#ddc390] hover:text-[#162028] cursor-pointer ${borderClasses}`}>
                <div className="flex items-start justify-between mb-8">
                  <div className="h-12 w-12 rounded-full border border-current/30 flex items-center justify-center group-hover:bg-[#162028] group-hover:text-[#ede2c4] transition-colors">
                    <Icon size={20} strokeWidth={1.7} />
                  </div>
                  <span className="text-[11px] font-mono opacity-50">0{i + 1}</span>
                </div>
                <h3 className="font-serif-display text-2xl md:text-[26px] leading-tight mb-3">{s.title}</h3>
                <p className="text-[14.5px] leading-relaxed opacity-80">{s.desc}</p>
                <div className="mt-8 inline-flex items-center gap-1.5 text-[12px] uppercase tracking-[0.2em] opacity-0 group-hover:opacity-100 transition-opacity">
                  Explore <ArrowUpRight size={14} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
